import React from 'react'
import PropTypes from 'prop-types'

import { Box, Fab, Tooltip } from '@mui/material'

import ClearIcon from '@mui/icons-material/Clear'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

const ActionCard = ({
  row,
  titleOnglet,
  setRow,
  setOpenCancel,
  fetchDataById,
  setOpenModal,
  setIsEditAction,
  setOpenModelDelete,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        placeContent: 'center',
        paddingRight: '15px',
      }}
    >
      <Tooltip
        title={<span className="tootltip-content">{`Annuler ${titleOnglet}`}</span>}
        arrow
      >
        <Fab
          sx={{
            backgroundColor: 'transparent',
            color: 'red',
            zIndex: 0,
            '&:hover': {
              backgroundColor: '#e3effa',
            },
          }}
          aria-label="close"
          variant="extended"
          className="fab-extended-button"
          onClick={(event) => {
            setRow(row)
            setOpenCancel(true)
            event.preventDefault()
          }}
          id={'Annuler'}
        >
          <ClearIcon />
        </Fab>
      </Tooltip>
      <Tooltip
        title={<span className="tootltip-content">{`Modifer ${titleOnglet}`}</span>}
        arrow
      >
        <Fab
          sx={{
            backgroundColor: 'transparent',
            color: '#1976D2',
            zIndex: 0,
            '&:hover': {
              backgroundColor: '#e3effa',
            },
          }}
          aria-label="close"
          variant="extended"
          className="fab-extended-button"
          onClick={(event) => {
            fetchDataById(row.id)
            setRow(row)
            setOpenModal(true)
            setIsEditAction(true)
            event.preventDefault()
          }}
          id={'Modifer'}
        >
          <EditIcon style={{ width: 22 }} />
        </Fab>
      </Tooltip>
      <Tooltip
        title={
          <span className="tootltip-content">{`Supprimer ${titleOnglet}`}</span>
        }
        arrow
      >
        <Fab
          sx={{
            backgroundColor: 'transparent',
            color: '#B70707',
            zIndex: 0,
            '&:hover': {
              backgroundColor: '#e3effa',
            },
          }}
          aria-label="close"
          variant="extended"
          className="fab-extended-button"
          onClick={(event) => {
            setRow(row)
            setOpenModelDelete(true)
            event.preventDefault()
          }}
          id={'Supprimer'}
        >
          <DeleteIcon />
        </Fab>
      </Tooltip>
    </Box>
  )
}
ActionCard.propTypes = {
  row: PropTypes.object,
  titleOnglet: PropTypes.string,
  setRow: PropTypes.func,
  setOpenCancel: PropTypes.func,
  fetchDataById: PropTypes.func,
  setOpenModal: PropTypes.func,
  setIsEditAction: PropTypes.func,
  setOpenModelDelete: PropTypes.func,
}
export default ActionCard
